export const fetchYoutubeVideo = async (videoId: string) => {
  const oembedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/shorts/${videoId}`;
  return fetch(oembedUrl)
    .then((res) => res.json())
    .then((data) => {
      return {
        videoId,
        title: data.title,
        thumbnailUrl: data.thumbnail_url,
        publishedAt: undefined, // This is not available in the oembed response
        description: undefined, // This is not available in the oembed response
        duration: undefined, // This is not available in the oembed response
      };
    });
};
